<template>
  <div>
    <TopPreview
      :dataList="c_topPreviewList"
      :model="topPreviewModel"
    />
    <div>
      <Success>
        <div slot="content">签约提车流程已完成，您可在【租赁中】模块继续管理车辆订单</div>
      </Success>
      <div class="bottom">
        <div class="button">
          <el-button @click="cancel" size="mini">关闭</el-button>
          <el-button @click="goAdd" size="mini">继续新建</el-button>
          <el-button @click="confirm" size="mini" type="primary">前往租赁中订单列表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// api
import {
  leaseContractOrderDetail,
} from '@/api/purchaseAndSaleAPI'
// 组件
import TopPreview from '../components/TopPreview'
import Success from '../../components/Success'
// 配置
// eslint-disable-next-line import/no-cycle
import publicConfig from '../config'

export default {
  components: {
    TopPreview,
    Success,
  },
  props: {
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      // 顶部预览配置
      c_topPreviewList,
    } = publicConfig.call(this)
    return {
      c_topPreviewList,
    }
  },
  mounted() {
    this.getLeaseContractOrderDetail()
  },
  methods: {
    // 获取详情
    getLeaseContractOrderDetail() {
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { data } = res
        if (data) {
          const {
            deptName,
            customerName,
            planName,
            modelName,
            plateNo,
            rentCategoryName,
            startDate,
            endDate,
            storeName,
          } = data
          /* eslint-disable vue/no-mutating-props */
          this.topPreviewModel.deptName = deptName
          this.topPreviewModel.customerName = customerName
          this.topPreviewModel.planName = planName || '自定义'
          this.topPreviewModel.modelName = modelName
          this.topPreviewModel.rentCategoryName = rentCategoryName
          this.topPreviewModel.plateNo = plateNo
          this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
          this.topPreviewModel.storeName = storeName
          /* eslint-enable vue/no-mutating-props */
        }
      })
    },
    cancel() {
      this.$refreshBack(true)
    },
    goAdd() {
      location.href = '/car_to_lease/forRentSignContract/personalSignContract'
    },
    confirm() {
      this.$refreshBack(true)
      this.$router.push('/underLease/underLeaseOrder')
    },
  },
}
</script>
<style lang="scss" scoped>
.bottom {
  text-align: center;

  .button {
    margin-top: 40px;
  }
}
</style>
